class ParallaxImage extends HTMLElement {
    constructor() {
        super(); // Always call super first in constructor

        // Attach a shadow root to the element.
        this.attachShadow({ mode: 'open' });
        this.shadowRoot.innerHTML = `
            <style>
                :host {
                    display: block;
                    overflow: clip;
                    position: relative;
                }
                ::slotted(img) {
                    position: absolute;
                    top: -20%;
                    bottom: -20%;
                    left: 0;
                    right: 0;
                    width: 100%;
                    height: 140% !important;
                    object-fit: cover;
                }
            </style>
            <slot></slot>
        `;
    }

    connectedCallback() {
        window.addEventListener('scroll', this._onScroll.bind(this));
    }

    disconnectedCallback() {
        window.removeEventListener('scroll', this._onScroll.bind(this));
    }

    _onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const parallaxRate = 0.5; // Adjust for different parallax effects
        const img = this.querySelector('img');
        if(img) {
            img.style.transform = `translateY(${scrollTop * parallaxRate}px)`;
        }
    }
}

// Define the new element
window.customElements.define('parallax-image', ParallaxImage);
